"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.frequencyToString = exports.getAlertValues = exports.toAlertValue = exports.AlertFrequency = void 0;
var AlertFrequency;
(function (AlertFrequency) {
    AlertFrequency[AlertFrequency["OFF"] = 0] = "OFF";
    AlertFrequency[AlertFrequency["DAILY"] = 1] = "DAILY";
    AlertFrequency[AlertFrequency["WEEKLY"] = 2] = "WEEKLY";
})(AlertFrequency = exports.AlertFrequency || (exports.AlertFrequency = {}));
exports.toAlertValue = function (enabled, frequency) {
    if (!enabled)
        return AlertFrequency.OFF;
    if (frequency.toLowerCase().trim() === 'daily')
        return AlertFrequency.DAILY;
    return AlertFrequency.WEEKLY;
};
exports.getAlertValues = function () { return [
    { key: 'daily', value: AlertFrequency.DAILY },
    { key: 'weekly', value: AlertFrequency.WEEKLY },
]; };
exports.frequencyToString = function (freq) {
    if (freq === AlertFrequency.DAILY)
        return 'Daily';
    if (freq === AlertFrequency.WEEKLY)
        return 'Weekly';
    return 'Daily';
};
